import BaseModel from 'common/models/base/model';

/**
 * wrapper around multiform submit. Note that
 * this file is generally created by a component, and
 * emitted to listener which most would most likely pass this
 * back to a model. (CC)
 */

// TODO - bind upload path
// TODO - ability to change upload path
export default BaseModel.extend({
  /**
   * properties
   */

  // private property on file - this is the form object submitting multipart data. Only way to do
  // this in the browser. (CC)
  _form: undefined,

  // the physical file content. We'll want to use this later when using pure JS
  // to upload files
  content: undefined,

  // name of the file to upload
  name: undefined,

  /**
   */

  initialize() {
    if (!this._form) throw new Error('_form must exist for file models');
  },

  /**
   * uploads the file to the browser
   */

  upload() {
    // currently unused
    // // jquery required to properly emit onsubmit
    // this._form.action = app.service.transport.getAPIPath(pathname);
    // $(this._form).submit();
    //
    // // nothing for now
    // return Promise.resolve();
  },
});
